import { Injectable, Injector } from "@angular/core";
import { RoleClient, TemplateRoleMemberOutputDto } from "../../core/remote-clients/remote-client";
import { firstValueFrom } from "rxjs";
import { RemoteResponse, RemoteServiceBase } from "./remote-base.service";

@Injectable()
export class RemoteRoleService extends RemoteServiceBase {
    protected readonly _roleClient: RoleClient;

    constructor(injector: Injector) {
        super(injector);

        this._roleClient = injector.get(RoleClient);
    }

    public async getPossibleRoleMembers(roleId: string, versionId: string, searchTerm: string): Promise<TemplateRoleMemberOutputDto[]> {
        const membersRequest = this.isGuest
            ? this._roleClient.possibleMemberGuest(roleId, versionId, searchTerm)
            : this._roleClient.possibleMember(roleId, versionId, searchTerm);

        const result = await firstValueFrom(membersRequest);

        this.validateResponse(result as RemoteResponse);

        return result.entity!;
    }
}